export function unproxy<T>(val: T): T {
  // destr(JSON.stringify(i))
  // return typeof val === 'object' ? cloneDeep(unref(val)) : unref(val)

  if (typeof val !== 'object') return unref(val)
  try {
    return helpers.tryCatch(() => {
      const str = JSON.stringify(unref(val))
      // if (str.length > 1000) console.trace('unproxy', str.length, val)
      // else console.trace('unproxy', val)
      return JSON.parse(str)
    })
  } catch (err) {
    console.trace('unproxy', err, val)
    return unref(val)
  }
}
